import { Matrix } from 'providers/Matrix';
import React, { useContext, useEffect, useState } from 'react';
import { useOuterClick } from 'providers/OutsideClick';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import DatePicker from 'components/_parts/atoms/ReactDatePickerWrapper';
import { useFormik } from 'formik';
import { Hooks } from 'providers';
import Select from 'react-select';
import moment from 'helpers/dayjsWrapper';
import dayjs from 'dayjs';
import * as Yup from 'yup';
// img
import { HIT_CREATE_MATRIX } from 'redux/actions/matrix';
import { HIT_LIST_MEMBER } from 'redux/actions/company';
import { HIT_WLA_ASSESSMENT } from 'redux/actions/wla';

import Img1 from 'assets/img/slide1_img.png';
import Img2 from 'assets/img/slide2_img.png';
import Img3 from 'assets/img/success_img.png';
import { useTranslation } from 'react-i18next';

// img
function AuditMatrix() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { listMember, memberCompany } = useSelector((state) => ({
    listMember: state?.organization?.list?.map((val, i) => ({
      value: val.employee_id,
      label: val.nama || 'no name',
    })),
    memberCompany: state?.company?.list?.map((value, i) => ({
      value: value.member_id,
      label: value.name || value.email,
    })),
  }));

  const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
  ];

  const {
    setModal, modal, setModalAssessment, modalAssessment,
  } = useContext(Hooks);
  const innerRef = useOuterClick((e) => {
    if (modalAssessment) {
      setModalAssessment(false);
      setModal(false);
    }
  });
  const dates = moment(new Date()).format('YYYY-MM-DD');

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const onChange = (dates) => {
    const [start, end] = dates;

    setStartDate(dates[0]);
    setEndDate(dates[1]);
    formik.setValues({
      ...formik.values,
      start_period: dayjs(dates[0]).format('YYYY-MM-DD'),
      end_period: dayjs(dates[1]).format('YYYY-MM-DD'),
    });
  };
  const [selectedValue, setSelectedValue] = useState([]);
  const handleChange = (e) => {
    setSelectedValue(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      members: selectedValue,
    });
  }, [selectedValue]);

  const formik = useFormik({
    initialValues: {
      start_period: '',
      end_period: '',
      members: [],
      board_id: localStorage.getItem('board_id'),
    },
    validationSchema: Yup.object().shape({
      start_period: Yup.string()
        .typeError('Range must be have a start')
        .required('Periode start'),
      end_period: Yup.string()
        .typeError('Range must be have a end')
        .required("Periode end can't be empty"),
      members: Yup.array().min(1, 'Member at least have once'),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.members[0] === 'All') {
        values.members = listMember?.map((val, i) => val.value);
      }
      await dispatch({
        type: HIT_WLA_ASSESSMENT,
        payload: {
          ...values,
          board_id: localStorage.getItem('board_id'),
        },
      });

      setModalAssessment(false);
      setStartDate(null);
      setEndDate(null);
      setSelectedValue('');
    },
  });

  const handleDate = (e) => {};

  // carousel
  const [now, setnow] = useState(1);
  const [trigger, setTrigger] = useState();
  useEffect(() => {
    setnow(trigger);
  }, [trigger]);
  useEffect(() => {
    if (trigger !== now) {
      setTimeout(() => {
        if (now === 1) {
          setnow(2);
        } else if (now === 2) {
          setnow(3);
        } else {
          setnow(1);
        }
      }, 3000);
    }
  }, [now]);
  // carousel
  return (
    <div
      className={`modal fade rModal ${modalAssessment && 'show'}`}
      id="assessment"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
      style={{
        width: 'fit-content',
        display: modal ? 'block !important' : 'none !important',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: 'fit-content',
      }}
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title float-left">
              {t('wla.analytics.assignment.title')}
            </h1>
          </div>
          <div className="modal-body m-2 inline-div">
            <div className="col-6">
              <div
                id="auditCarousel"
                className="carousel slide"
                data-ride="carousel"
              >
                <ol className="carousel-indicators">
                  <li
                    data-target="#auditCarousel"
                    data-slide-to="0"
                    onClick={() => {
                      setnow(1);
                      setTrigger(1);
                    }}
                    className={`${now === 1 && 'active'}`}
                  />
                  <li
                    data-target="#auditCarousel"
                    data-slide-to="1"
                    onClick={() => {
                      setnow(2);
                      setTrigger(2);
                    }}
                    className={`${now === 2 && 'active'}`}
                  />
                  <li
                    data-target="#auditCarousel"
                    data-slide-to="2"
                    onClick={() => {
                      setnow(3);
                      setTrigger(3);
                    }}
                    className={`${now === 3 && 'active'}`}
                  />
                </ol>
                <div className="carousel-inner">
                  <div className={`carousel-item ${now === 1 && 'active'}`}>
                    <img className="rModalImg" src={Img1} alt="First slide" />
                    <span>{t('wla.analytics.assignment.process')}</span>
                  </div>
                  <div className={`carousel-item ${now === 2 && 'active'}`}>
                    <img
                      className="rModalImg"
                      src={Img2}
                      alt="Second slide"
                    />
                    <span>
                      {t('wla.analytics.assignment.select_personnel')}
                    </span>
                  </div>
                  <div className={`carousel-item ${now === 3 && 'active'}`}>
                    <img className="rModalImg" src={Img3} alt="Third slide" />
                    <span>{t('wla.analytics.assignment.start_audit')}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
              <form onSubmit={() => formik.handleSubmit()}>
                <label>
                  {t('wla.analytics.assignment.assesment_period')}
                </label>
                <DatePicker
                  className="form-control w-100"
                    //   id={startDateId}
                  selected={startDate}
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  placeholderText={t(
                    'wla.analytics.assignment.dropdown_placeholder1',
                  )}
                    //   dateFormat={displayFormat}
                  onChange={onChange}
                />
                {formik.touched.start_period && formik.errors.start_period ? (
                  <span className="error">
                    {formik.errors.start_period}
                    {' '}
                    {' - '}
                  </span>
                ) : null}
                {formik.touched.end_period && formik.errors.end_period ? (
                  <span className="error">{formik.errors.end_period}</span>
                ) : null}

                <hr />
                <label>{t('wla.analytics.assignment.invite_member')}</label>
                <Select
                  options={[
                    { value: 'All', label: 'Select All' },
                    ...(memberCompany ?? []),
                  ]}
                  isMulti
                  value={[
                    { value: 'All', label: 'Select All' },
                    ...(memberCompany ?? []),
                  ]?.filter((obj) => selectedValue?.includes(obj.value))}
                  onChange={handleChange} // assign onChange function
                  placeholder={t(
                    'wla.analytics.assignment.dropdown_placeholder2',
                  )}
                />
                {/* <span className="custom-control-label rCAcc">Check All</span> */}
                {formik.touched.members && formik.errors.members ? (
                  <span className="error">{formik.errors.members}</span>
                ) : null}
                <div className="text-center mt-3 col-md-12 float-right inline-div">
                  <span
                    className="rBacc col-6 p-2 pointer mr-2"
                    onClick={() => {
                      setModalAssessment(false);
                      setModal(false);
                    }}
                  >
                    {t('wla.analytics.assignment.button_cancel')}
                  </span>
                  <button
                    type="button"
                    className="btn btn-lg btn-primary bt100 btnRprim col-6"
                    onClick={(e) => {
                      formik.handleSubmit(e);
                    }}
                  >
                    {t('board.submit')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuditMatrix;
